import { useEffect, useState } from "react";

const KEY = "sbi_theme";

export function getInitialTheme() {
  if (typeof window === "undefined") return "dark";
  return localStorage.getItem(KEY) || "dark";
}

export function applyTheme(t) {
  const root = document.documentElement;
  if (t === "dark") {
    root.classList.add("dark");
    root.classList.remove("light");
  } else {
    root.classList.remove("dark");
    root.classList.add("light");
  }
  localStorage.setItem(KEY, t);
}

export function useTheme() {
  const [theme, setTheme] = useState(getInitialTheme());
  useEffect(() => {
    applyTheme(theme);
  }, [theme]);
  return [theme, setTheme];
}
